import * as r from 'ramda';
import {regReducer} from '../../core';
import * as actions from './actions';

// example of the state
// const loading = {
//     productConfigurator: new Set('named'),
// };

function loadingPath(ns) {
    return ['loading', ns];
}

regReducer(actions.SHOW, (state, {payload}) => {
    const statePath = loadingPath(payload.ns);
    const ids = new Set(r.pathOr([], statePath, state));
    ids.add(payload.id);

    return r.assocPath(statePath, ids, state);
});

regReducer(actions.HIDE, (state, {payload}) => {
    const statePath = loadingPath(payload.ns);
    const ids = new Set(r.pathOr([], statePath, state));
    ids.delete(payload.id);

    return r.assocPath(statePath, ids, state);
});
